import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick", "innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('quick-reply-wrapper'))
  }, [
    _createElementVNode("ul", {
      "aria-label": "quick replies",
      class: _normalizeClass(_ctx.getClass('button ') + _ctx.getClass('quickReply ')  + (
            (_ctx.messageContentsettings.showOneQuickReplyPerLine !== null && _ctx.messageContentsettings.showOneQuickReplyPerLine) ?
            _ctx.getClass('singleQuickReplyPerLine ') : ' ')),
      role: "list"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (value, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_ctx.getClass('quick-reply-item')),
          role: "listitem"
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.getClass('btn ' ) + _ctx.getClass('btnQuickReply ') + (
                    (_ctx.messageContentsettings.showOneQuickReplyPerLine !== null && _ctx.messageContentsettings.showOneQuickReplyPerLine) ?
                    _ctx.getClass('btnQuickReplyPerLine ') : ' ')),
            onClick: $event => (_ctx.onClick(index, $event)),
            ref_for: true,
            ref: 'quickReplyBtn_' + index,
            innerHTML: _ctx.formatMessageContent(value.label)
          }, null, 10 /* CLASS, PROPS */, _hoisted_1)
        ], 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}